export const PLAYLIST_TAB = 'PLAYLIST';
export const DEEP_SEARCH_TAB = 'DEEP_SEARCH';
export const CHAPTERS_TAB = 'CHAPTERS';
export const TRANSCRIPTS_TAB = 'TRANSCRIPTS';
export const COMMENTS_TAB = 'COMMENTS';
export const SLIDES_TAB = 'SLIDES';

export const TAB_ENUMS = [
  PLAYLIST_TAB,
  DEEP_SEARCH_TAB,
  CHAPTERS_TAB,
  TRANSCRIPTS_TAB,
  COMMENTS_TAB,
  SLIDES_TAB,
] as const;
